'use client'

import React, { PropsWithChildren } from 'react'
import { 
    Dialog,
    DialogContent, 
    DialogDescription, 
    DialogTitle, 
    DialogTrigger 
} from '../ui/dialog'

type FormDialogProps = {
    isOpen?: boolean;
    setIsOpen?: (isOpen: boolean) => void;
    title: string;
    description: string;
    trigger: React.ReactNode;
}

/** Prevent closing when interacting with Google Places Autocomplete dropdown (pac-container) */
function handleOutsideInteraction(e: Event) {
    const target = e.target as HTMLElement
    if (target?.closest?.('.pac-container')) {
        e.preventDefault()
    }
}

function FormDialog({ 
    isOpen, 
    setIsOpen, 
    children,
    title,
    description,
    trigger
}: PropsWithChildren<FormDialogProps>) {
    return (
        <Dialog open={isOpen} onOpenChange={setIsOpen}>
            <DialogTrigger asChild>
                {trigger}
            </DialogTrigger>
            <DialogContent 
                className='pt-10 pb-7 px-5 max-w-[600px] md:max-w-[900px] lg:max-w-6xl max-h-[80vh] w-[90%] overflow-y-auto grid-rows-[auto_1fr] md:px-8 md:pt-10 md:pb-8'
                aria-describedby={undefined}
                onPointerDownOutside={handleOutsideInteraction}
                onInteractOutside={handleOutsideInteraction}
            >
                <div className="flex items-center flex-col gap-2 text-center w-full">
                    <DialogTitle className='text-2xl font-bold text-center w-full'>{title}</DialogTitle>
                    <DialogDescription className='text-center w-full'>{description || ' '}</DialogDescription>
                </div>
                {children}
            </DialogContent>    
        </Dialog>
    )
}

export default FormDialog
